import { render, staticRenderFns } from "./input.vue?vue&type=template&id=2bc9130d&scoped=true&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=2bc9130d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9130d",
  null
  
)

export default component.exports